module.exports = __webpack_public_path__ + "static/media/sf-test-15.a43472db.mp3";